'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class LimitesDisponibles extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { limiteDisponible } = this.props

        return <div className="container-fluid saldos-resumenes">
            <table className="table">
                <thead>
                    <tr>
                        <th>
                        </th>
                        <th>
                            <label className="label-saldos-resumenes-header">ASIGNADO</label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <label className="label-saldos-resumenes-body">Límite de Compra:</label>
                        </td>
                        <td>
                            <MontoMask class={"label-saldos-resumenes-body"} monto={limiteDisponible && limiteDisponible.LimiteDeCompra} moneda={"pesos"} />
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <label className="label-saldos-resumenes-body">Límite de Compra en CUOTAS:</label>
                        </td>
                        <td>
                            <MontoMask class={"label-saldos-resumenes-body"} monto={limiteDisponible && limiteDisponible.LimiteCompraCuotas} moneda={"pesos"} />
                        </td>
                    </tr>

                    {/* TODO: Por ahora dejar oculto este registro - Tarea #20126
                        <tr>
                            <td>
                                <label className="label-primary">Límites de Adelantos en cuotas:</label>
                            </td>
                            <td>
                                <label className="label-primary">$ 10.000,00</label>
                            </td>
                        </tr>*/}

                    <tr>
                        <td>
                            <label className="label-saldos-resumenes-body">Límite de Financiación:</label>
                        </td>
                        <td>
                            <MontoMask class={"label-saldos-resumenes-body"} monto={limiteDisponible && limiteDisponible.LimiteFinanciacion} moneda={"pesos"} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

}
export default LimitesDisponibles;